import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { PackageOpen, TrendingUp, TrendingDown, AlertTriangle, CheckCircle2, Clock } from 'lucide-react';

export function AgroRatesKpi() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng mã vật tư',
      value: '245',
      icon: PackageOpen,
      trend: { value: 12, isPositive: true },
      color: 'blue'
    },
    {
      title: 'Vật tư vượt dự toán',
      value: '18',
      icon: TrendingUp,
      trend: { value: 5, isPositive: false },
      color: 'red'
    },
    {
      title: 'Mức vượt trung bình',
      value: '12.4%',
      icon: AlertTriangle,
      color: 'orange'
    },
    {
      title: 'Cần cập nhật giá',
      value: '45',
      icon: Clock,
      color: 'yellow'
    },
    {
      title: 'Tiết kiệm chi phí',
      value: '12',
      icon: TrendingDown,
      trend: { value: 3, isPositive: true },
      color: 'emerald'
    },
    {
      title: 'Đang chờ duyệt',
      value: '8',
      icon: CheckCircle2,
      color: 'indigo'
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
